import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M4.828 8.274a.25.25 0 0 0-.128-.1 5.5 5.5 0 0 1-2.084-1.291 3 3 0 0 1-.216-.236.25.25 0 0 0-.413.037L.571 9.249a.5.5 0 0 0 .438.742h4a.5.5 0 0 0 .422-.768Zm4.434-1.669a.57.57 0 0 0 .062-.861L6.982 3.4 8.2 2.183a.625.625 0 0 0-.883-.883L6.1 2.518 3.756.176a.57.57 0 0 0-.4-.167h-.041A.57.57 0 0 0 2.9.238a4.549 4.549 0 0 0 6.362 6.367"
    }, null, -1)
  ]));
}
const interfaceShareSatellite = { render };
export {
  interfaceShareSatellite as default,
  render
};
//# sourceMappingURL=interface-share-satellite.svg.js.map
